import AccountPageOnlyTradingTable from './AccountPageOnlyTradingTable';

export default AccountPageOnlyTradingTable;
